module.exports = __webpack_public_path__ + "img/SE.33d00469.svg";